import { createGlobalStyle } from "antd-style";

export const GlobalFont = createGlobalStyle`

  @font-face { 
    font-family: "Lato";
    font-weight: 400;
    font-style: normal;
    src: url('/fonts/Lato-Regular.woff2') format('woff2');
  }

  @font-face { 
    font-family: "Lato";
    font-weight: 700;
    font-style: normal;
    src: url('/fonts/Lato-Bold.woff2') format('woff2');
  }
`;
